var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-4 col-form-label text-md-right"},[_vm._v("Φόρτωση Αρχείου")]),_c('div',{staticClass:"col-md-2"},[_c('input',{ref:"file",attrs:{"type":"file","id":"fileUpload"},on:{"change":_vm.handleFileUpload}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }